import React from 'react';
import PropTypes from 'prop-types';

import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Tooltip from 'components/tooltip';
import UncollectedAmountTable from './table';
import { USD } from 'helpers/formatters/number_formats';

import './styles.scss';

export default function UncollectedAmount({ deal }) {
  if (deal.voucherAssociation === null || !deal.receivables.length) return <div>--</div>;

  const uncollectedAmount = deal.receivables.reduce((unpaid, receivable) => unpaid + receivable.amountUnpaid, 0);

  if (uncollectedAmount === 0) return <div>Fully Paid</div>;

  return (
    <Tooltip
      content={
        <UncollectedAmountTable receivables={deal.receivables}/>
      }
      overlayClassName="uncollected-amount-tooltip"
    >
      <span>{USD.format(uncollectedAmount)}<FontAwesomeIcon className="ml-1" icon={faInfoCircle} size="sm" /></span>
    </Tooltip>
  );
}

UncollectedAmount.propTypes = {
  deal: PropTypes.shape(
    {
      receivables: PropTypes.array.isRequired,
      voucherAssociation: PropTypes.object,
    },
  ).isRequired,
};
